import * as React from "react";
const SvgFiRrTachometerAverage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14 13a1.998 1.998 0 0 1-3 1.732 2 2 0 0 1 0-3.464V6a1 1 0 0 1 2 0v5.268A2 2 0 0 1 14 13m6-8.948A12 12 0 0 0 3.555 21.516a3.016 3.016 0 0 0 4.073.129l1.026-.888a1 1 0 1 0-1.308-1.514l-1.027.889a1 1 0 0 1-1.357-.038 10 10 0 1 1 14.114-.037 1.02 1.02 0 0 1-1.395.074l-1.027-.888a1.001 1.001 0 0 0-1.308 1.514l1.027.887a3.034 3.034 0 0 0 4.118-.174 12.056 12.056 0 0 0-.49-17.418"
    />
  </svg>
);
export default SvgFiRrTachometerAverage;
